import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { StoreAccessoryRequestUpdate } from '../../../../../models/api-store/store-accessory/store-accessory.request.model';
import { StoreAccessoryResponseGet } from '../../../../../models/api-store/store-accessory/store-accessory.response.model';
import { StoreAccessoryService } from '../../../../../services/api-store/store-accessory/store-accessory.service';

@Component({
  selector: 'app-accessoristore-edit',
  templateUrl: './accessoristore-edit.component.html'
})
export class AccessoristoreEditComponent implements OnInit {

  @Input() public id:number;

  objModel:StoreAccessoryRequestUpdate;
  objGetModel: StoreAccessoryResponseGet;
  formBuilder: FormGroup;
  activeButtonSave:boolean;
  
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private storeAccessoryService: StoreAccessoryService,
    private toastr: ToastrService,
  ) { 
    this.formBuilder = this.fb.group({
      index: [''],
      name: ['',[Validators.required]]
    });
    this.activeButtonSave = true;
  }

  ngOnInit(): void {
    this.init();
  }

  isValidID(){
    let res = false;
    if(this.id != null && typeof this.id != typeof undefined){
      res = true;
    }
    return res;
  }
  
  init(){
    if(this.isValidID()){
      this.storeAccessoryService.getEntity(this.id).subscribe(
        (response) => {
          this.objGetModel = response;
          this.formBuilder = this.fb.group({
            index: [response.index],
            name: [response.name,[Validators.required]]
          });
        },
        (error: HttpErrorResponse)=>{
          this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni dell\'accessorio' , 'Modifica immagine', {
            timeOut: 5000
          });
          this.activeModal.close('CLOSE');
        }
      );
    }
  }
  
  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }

  save(){

    if(this.formBuilder.status === 'VALID'){
      this.activeButtonSave = false;
      this.objModel = this.formBuilder.value;
      this.storeAccessoryService.update(this.id,this.objModel).subscribe(
        (response)=>{
          this.toastr.success('Accessorio modificato con successo', 'Modifica accessorio');
          this.activeButtonSave = true;
          this.activeModal.close(response);
        },
        (error)=>{
          console.log(error);
          this.activeButtonSave = true;
          this.toastr.error('Si è verificato un errore durante la modifica dell\'accessorio' , 'Modifica accessorio fallita', {
            timeOut: 5000
          });
        }
      );
    }
  }

  cancel() {
    this.activeModal.close('CLOSE');
  }

}
